import { createFileRoute } from '@tanstack/react-router'
import { useLocale, useTranslations } from 'use-intl'

import { PublicLayout } from '~/components/layout/public-layout'
import { resolveImplementedLocale } from '~/lib/i18n/shared'
import { relativeNavigationTargetSchema } from '~/lib/navigation/football-core'

export const Route = createFileRoute('/forbidden')({
  validateSearch: search => ({
    returnTo: relativeNavigationTargetSchema.optional().parse(search.returnTo),
  }),
  component: ForbiddenRoute,
})

function ForbiddenRoute() {
  const locale = resolveImplementedLocale(useLocale())
  const t = useTranslations('AccessDenied')
  const matchesPath = locale === 'zh-CN' ? '/zh-CN/matches' : '/matches'

  return (
    <PublicLayout>
      <div className="mx-auto w-full max-w-3xl px-4 py-12 sm:px-6 sm:py-16">
        <nav data-breadcrumbs aria-label={t('breadcrumbLabel')} className="text-sm text-muted">
          <a className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-lg font-bold text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" href={matchesPath}>
            {t('matches')}
          </a>
          <span aria-hidden="true" className="mx-2">/</span>
          <span aria-current="page">{t('breadcrumb')}</span>
        </nav>
        <section className="mt-4 rounded-2xl border border-divider bg-content1 p-6 shadow-sm sm:p-10" aria-labelledby="forbidden-title">
          <p className="text-sm font-black tabular-nums text-danger">403</p>
          <h1 id="forbidden-title" className="break-words text-3xl font-black tracking-tight text-foreground">{t('title')}</h1>
          <p className="mt-3 max-w-2xl leading-7 text-muted">{t('body')}</p>
          <a className="mt-6 inline-flex min-h-11 min-w-11 items-center justify-center rounded-xl bg-primary px-4 font-bold text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" href={matchesPath}>
            {t('action')}
          </a>
        </section>
      </div>
    </PublicLayout>
  )
}
